import { createTheme } from '@mui/material/styles';

// Define the blue color (standard MUI blue)
const primaryBlue = '#1976d2';
const lightBackground = '#f4f6f8'; // A light grey background
const cardBackground = '#ffffff'; // White background for cards/papers

export const theme = createTheme({
    palette: {
        primary: {
            main: primaryBlue,
        },
        secondary: { // Add a secondary color for variety
            main: '#9c27b0', // MUI purple
        },
        background: {
            default: lightBackground,
            paper: cardBackground,
        },
        // You might want to define error, warning, info, success colors too
    },
    typography: {
        // Define any custom typography variants if needed
        // h4: {
        //     fontWeight: 'bold',
        //     color: primaryBlue,
        //     marginBottom: '1rem', 
        // },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: '1.5rem', // Default padding for Paper
                    borderRadius: '8px', // Slightly rounded corners
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)', // Subtle shadow
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '6px',
                    padding: '8px 16px', // Consistent padding
                },
                containedPrimary: {
                    fontWeight: 'bold',
                },
                outlined: {
                    borderWidth: '1px',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                }
            }
        },
        MuiListItemButton: { // Style list item buttons for sidebar
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                    marginBottom: '4px', // Add slight spacing
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(25, 118, 210, 0.08)', // Light blue background when selected
                        '&:hover': {
                            backgroundColor: 'rgba(25, 118, 210, 0.12)', // Slightly darker on hover when selected
                        },
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Subtle hover for non-selected items
                    },
                }
            }
        },
        MuiListItemIcon: { // Adjust icon margin in list items
            styleOverrides: {
                root: {
                    minWidth: '40px',
                }
            }
        }
    },
}); 